import gql from 'graphql-tag';

export const GET_DEALER_LOCATIONS_OPTIONS = gql`
  query GetDealerLocationsOptions($dynamicsId: ID) {
    dealerLocationsOptions: publicAccount(dynamicsId: $dynamicsId) {
      locations {
        value: locationId
        label: locationName
        childrenLocation {
          value: locationId
          label: locationName
        }
      }
    }
  }
`;
